module.exports = __webpack_public_path__ + "media/images/new_home/dig-in-day-logo-9828f42fda5bba7be14193d60eae21e3.png";